if (!customElements.get('estimated-delivery')) {
  class EstimatedDelivery extends HTMLElement {
    connectedCallback() {
      this.output = this.querySelector('[data-delivery-range]');

      if (!this.output) return;

      this.updateDeliveryRange();
      this.scheduleMidnightUpdate();
    }

    disconnectedCallback() {
      if (this.midnightTimer) {
        clearTimeout(this.midnightTimer);
      }
    }

    addBusinessDays(startDate, numberOfDays) {
      const date = new Date(startDate);
      let daysAdded = 0;

      while (daysAdded < numberOfDays) {
        date.setDate(date.getDate() + 1);

        const dayOfWeek = date.getDay();

        if (dayOfWeek !== 0 && dayOfWeek !== 6) {
          daysAdded += 1;
        }
      }

      return date;
    }

    formatDeliveryRange(earliestDate, latestDate) {
      const locale =
        document.documentElement.lang ||
        navigator.language ||
        'en-CA';

      const options = {
        month: 'long',
        day: 'numeric'
      };

      if (earliestDate.getFullYear() !== latestDate.getFullYear()) {
        options.year = 'numeric';
      }

      const formatter = new Intl.DateTimeFormat(locale, options);

      if (typeof formatter.formatRange === 'function') {
        return formatter.formatRange(earliestDate, latestDate);
      }

      return `${formatter.format(earliestDate)} – ${formatter.format(latestDate)}`;
    }

    updateDeliveryRange() {
      const now = new Date();

      const today = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        12
      );

      const minimumBusinessDays =
        Number.parseInt(this.dataset.minimumBusinessDays, 10) || 5;

      const maximumBusinessDays =
        Number.parseInt(this.dataset.maximumBusinessDays, 10) || 7;

      const earliestDate = this.addBusinessDays(
        today,
        minimumBusinessDays
      );

      const latestDate = this.addBusinessDays(
        today,
        maximumBusinessDays
      );

      this.output.textContent = this.formatDeliveryRange(
        earliestDate,
        latestDate
      );
    }

    scheduleMidnightUpdate() {
      const now = new Date();

      const nextMidnight = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate() + 1,
        0,
        0,
        1
      );

      this.midnightTimer = setTimeout(() => {
        this.updateDeliveryRange();
        this.scheduleMidnightUpdate();
      }, nextMidnight.getTime() - now.getTime());
    }
  }

  customElements.define('estimated-delivery', EstimatedDelivery);
}